import React from 'react'

import { useFormikContext } from 'formik'

import { ReimbursementMethod } from 'core/domain/expenses/reimbursementMethod'

import Option from 'common/components/dataEntry/components/Option'
//import Select from "common/components/dataEntry/formik/FormikSelectWithChildrenField";
import Select from 'common/components/dataEntry/formik/FormikDefaultSelectField'

export const reimbursementMethodsTitleMap = new Map<ReimbursementMethod, string>([
  [ReimbursementMethod.Cash, 'Cash'],
  [ReimbursementMethod.Check, 'Check'],
  [ReimbursementMethod.Payroll, 'Payroll'],
  [ReimbursementMethod.Other, 'Other'],
])

const reimbursementMethods = [
  ReimbursementMethod.Cash,
  ReimbursementMethod.Check,
  ReimbursementMethod.Payroll,
  ReimbursementMethod.Other,
]

const reimbursementMethodSelectOptions = reimbursementMethods.map((action) => (
  <Option key={action} value={action}>
    {reimbursementMethodsTitleMap.get(action)}
  </Option>
))

interface ReimburesementMethodProps {
  translate: (key: string) => string
}

const ReimburesementMethod: React.FC<ReimburesementMethodProps> = ({ translate }) => {
  const formik = useFormikContext<any>()

  const getSelectValue = (selectValue: ReimbursementMethod, overrideValue: any) => {
    if (reimbursementMethodsTitleMap.has(selectValue) || selectValue) {
      return [selectValue]
    } else if (overrideValue) {
      return [overrideValue]
    } else return [translate('admin-dashboard.reimbursements.reimbursements-due.select-one-label')]
  }

  return (
    <Select
      name="reimbursementMethodSelect"
      label={translate('admin-dashboard.reimbursements.reimbursements-due.reimbursement-method-label')}
      value={getSelectValue(formik.values.reimbursementMethodSelect, formik.values.reimbursementMethodOverride)}
      placeholder={translate('admin-dashboard.reimbursements.reimbursements-due.select-one-label')}
      //dropdownMatchSelectWidth={false}
      //customOptionPlaceholder={translate("admin-dashboard.reimbursements.reimbursements-due.other-placeholder")}
      // customOption={
      //   <Input
      //     name="reimbursementMethodOverride"
      //     placeholder={translate("admin-dashboard.reimbursements.reimbursements-due.please-specify-placeholder")}
      //   />
      // }
    >
      {reimbursementMethodSelectOptions}
    </Select>
  )
}

export default ReimburesementMethod
